import { IMAGES } from "../lib/site";
import { FadeUp, MaskedLine } from "./Reveal";

const Founder = () => (
    <section className="relative bg-ever text-white overflow-hidden" data-testid="founder-section">
        <div className="spotlight" />
        <div className="relative mx-auto max-w-[1440px] px-5 sm:px-10 py-16 sm:py-24 grid gap-14 lg:grid-cols-[1.4fr_1fr] lg:gap-20 items-center">
            <div>
                <FadeUp>
                    <p className="font-mono text-[10px] sm:text-xs tracking-[0.3em] uppercase text-brass mb-6">
                        The studio behind the brand
                    </p>
                </FadeUp>
                <h2 className="font-serif font-light leading-[1.05] tracking-tight text-[clamp(2.2rem,4.5vw,4rem)]">
                    <MaskedLine>A venture by</MaskedLine>
                    <MaskedLine delay={0.1}>
                        <em className="italic text-brass">Spaces by Samita.</em>
                    </MaskedLine>
                </h2>
                <FadeUp delay={0.2}>
                    <p className="mt-8 max-w-xl text-sm sm:text-base font-light leading-relaxed text-white/70">
                        Bath & Beyond is a bathroom renovation company in Bangalore and the
                        bathroom-renovation venture of Spaces by Samita, the
                        interior design studio led by designer Samita Menon. Every renovation is
                        designed under her eye &mdash; one aesthetic, one standard, one team from the
                        first sketch to the final handover.
                    </p>
                </FadeUp>
                <FadeUp delay={0.3}>
                    <blockquote className="mt-10 border-l-2 border-brass pl-6 sm:pl-8" data-testid="founder-quote">
                        <p className="font-serif italic font-light text-xl sm:text-2xl leading-snug text-white/90">
                            "A bathroom should be the most personal luxury in your home. We treat it
                            that way."
                        </p>
                        <cite className="mt-4 block font-mono text-[10px] tracking-[0.3em] uppercase text-brass not-italic">
                            Samita Menon &mdash; Founder, Spaces by Samita
                        </cite>
                    </blockquote>
                </FadeUp>
            </div>

            <FadeUp delay={0.15}>
                <figure className="relative group overflow-hidden" data-testid="founder-image">
                    <div className="aspect-[4/5]">
                        <img
                            src={IMAGES.faucet}
                            alt="Brass fittings detail"
                            loading="lazy"
                            className="h-full w-full object-cover img-treated transition-transform duration-[1.2s] ease-out group-hover:scale-[1.05]"
                        />
                    </div>
                    <figcaption className="absolute bottom-0 inset-x-0 flex items-center justify-between gap-4 bg-gradient-to-t from-noir/90 to-transparent p-6 sm:p-8">
                        <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-white/80">
                            Designed, not assembled
                        </span>
                        <span className="font-serif italic text-brass text-xl">S by S</span>
                    </figcaption>
                </figure>
            </FadeUp>
        </div>
    </section>
);

export default Founder;
